import { render, staticRenderFns } from "./IsLoading.vue?vue&type=template&id=2ce90c59&"
import script from "./IsLoading.vue?vue&type=script&lang=js&"
export * from "./IsLoading.vue?vue&type=script&lang=js&"
import style0 from "./IsLoading.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports